export const celebrateReflectionWeekScopeRoot = ['celebrateReflectionWeekScope'] as const;

export const actionsKeys = {
  action: ['action'] as const,
  list: ['actions'] as const,
  selectedDate: (date?: Date) => ['actions', date],
  actionsAndBlock: ['completedActionsAndBlock'] as const,
};
